import { RootState } from 'editor/src/store/index';

const isMultipleImageSelectAllowed = (state: RootState) => state.hostSettings.allowSelectMultipleImages;

export default isMultipleImageSelectAllowed;
